module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upload-img"
  }, _vm._l((_vm.urlArr), function(item, inx) {
    return _c('el-image', {
      key: inx,
      staticStyle: {
        "width": "100px",
        "height": "100px"
      },
      attrs: {
        "src": item.url,
        "preview-src-list": item.list
      }
    })
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.1.0@vue-loader/lib/template-compiler?{"id":"data-v-dad92e34"}!./~/_vue-loader@12.1.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/industryInfos/buildingInfos/imgsUpload.vue
// module id = 1571
// module chunks = 1